import React from 'react';
import {createRoot} from "react-dom/client";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const div = document.createElement("div");
document.body.appendChild(div);
createRoot(div).render(<ToastContainer/>);
